export default {
  QOS: 'QoS策略',
  AccessRuleTitle: '服务质量QoS（Quality of Service）用于网络资源的合理调配，解决网络延迟和阻塞等问题。通过设置QoS策略，可以帮助您区分不同应用和不同业务的流量，保证关键业务流量的带宽，提高您网络资源的利用率，保证网络的质量。', // qos的访问规则的标题
  AccessRuleDesc: 'QoS策略目前仅支持出方向的限速，暂不支持入方向的限速，请知悉。', // qos的访问规则的描述
  MinMaxBandwidth: '最小/最大带宽',
  RelatedTitle: '流量默认按照QoS策略规则优先级，从高到低进行匹配。若优先级相同，将默认按照创建时间早的规则优先生效。当带宽不足时将优先保证高优先级限速规则下的流量带宽。', // qos的已关联网关的标题
  SpecialNote: '特别提示：批量操作仅用于新增关联关系，访问规则原绑定的网关关系将保留，不会被修改。如有需要，可前往',
  QosPlotRelatedNet: 'QoS策略-已关联网关',
  ToManage: '下进行管理。', // SpecialNote和QosPlotRelatedNet和ToManage本为一句话由于有可点击链接，所以拆分
  BatchDeleteQos: '批量删除策略',
  AreYouSureDeleteQos: '您确定要批量删除这些策略吗?',
  LimitBandwidth: '限速带宽',
  NotSetLimitRule: '该优先级还未配置过限速规则，请先配置',
  ToSet: '去配置',
  LimitPriority: '限速优先级',
  ConfigPlot: '配置策略',
  ChangeTime: '最近修改时间',
  PlotName: '策略名称',
  SearchPlotName: '搜索策略名',
  RemoveRelatedQos: '移除已选择的策略，将与当前网关解绑。网关实例通过匹配规则过滤流量。未关联网关则规则不会生效。添加策略只支持当前账号创建的策略。',
  SelectAddQos: '选择添加策略',
  RelationQosMore: (val: number) => `网关关联的策略数超过${val}条，请修改后重试`,
  ConfigedPlot: '已配置策略',
  DefaultLimitConfig: '默认限速配置',
  AllGatewayMoreThan: (gatewayNames: string) => `网关 ${gatewayNames} 关联的策略数量已达上限,请重新选择网关`,
}